module.exports = "/packs/images/google_play_badge~c5b26b45a4c1c6f437f968a9a281359c.png";